import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import EdgeLogo from "components/Design/EdgeLogo/EdgeLogo";
import Footer from "components/Screens/LoginV2/Footer/Footer";
import ReferralOverlay from "components/Screens/LoginV2/ReferralOverlay/ReferralOverlay";

import { s3ImagesBaseURL } from "util/APIBaseUrl";

import LoginImageVector from "assets/svgs/LoginImageVector";

import "./Layout.scss";

function Layout({
  children,
  showLogo = true,
  rightSideText = "Match Your Ambition",
  padding = "0rem",
  rightSideImage = `${s3ImagesBaseURL}/login-image.jpg`,
  showReferralOverlay = false,
  contentContainerClass = "",
  backgroundColor = "",
  backgroundColorClass = "bg-white",
}) {
  return (
    <Grid container className={`login-container ${backgroundColorClass}`} spacing={0}>
      <Grid
        container
        style={{ padding }}
        data-testid="login-left-grid"
        size={{
          xl: 6,
          lg: 6,
          md: 6,
          sm: 12,
          xs: 12
        }}>
        <div className="login-left" style={{ backgroundColor }}>
          {showLogo && (
            <div className="logo-container">
              <EdgeLogo size="lg" data-testid="edge-logo" />
            </div>
          )}

          <div className={` ${contentContainerClass}`}>{children}</div>

          <div className="footer-container">
            <Footer data-testid="footer" />
          </div>
        </div>
      </Grid>
      <Grid
        container
        className="login-right"
        size="grow"
        size={{
          xl: 6,
          lg: 6,
          md: 6,
          sm: 12,
          xs: 12
        }}>
        <div
          className="image-container"
          data-testid="image-container"
          style={{
            backgroundImage: `url(${rightSideImage})`,
          }}
        >
          {showReferralOverlay ? (
            <ReferralOverlay />
          ) : (
            <>
              <div className="image-vector">
                <LoginImageVector />
              </div>
              <div className="text-overlay-container">
                <div className="gradient-overlay" />
                <div className="display-h3-semibold layout-image-text">{rightSideText}</div>
              </div>
            </>
          )}
        </div>
      </Grid>
    </Grid>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  showLogo: PropTypes.bool,
  rightSideText: PropTypes.string,
  padding: PropTypes.string,
  rightSideImage: PropTypes.string,
  showReferralOverlay: PropTypes.bool,
  contentContainerClass: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default Layout;
